import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import '../../../styles/assets/css/pages/form5.css'
import { loadLocationWithMessage } from '../../../actions/location'
import { tqe_q1_2, tqe_q3a, tqe_q3b, tqe_q4a, tqe_q4b, tqe_q5_6, answers_q1,
  answers_q2, answers_q3a, answers_q3b, answers_q4a, answers_q4b } from '../variables/assessments/tqe.js'
import { calculateTimepoint1, calculateTimepoint3_1 } from '../../functions/timepoint.js'

import WarningIcon from '@material-ui/icons/Warning'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import StepperAssm from './stepper_assm'
import { initAutosaveForForm, ensureAutosaveInitialized, detachAutosave } from '../../utils/draftAutosaveManager'

class Tqe extends Component {
  constructor(props) {
    super(props)
    this.state = {
        status: 1,
        is_time_available: true,
        message: '',
        start_time: Math.floor(new Date().getTime()/1000),
        start_datetime: new Date().toLocaleString('en-US', { hour12: false }).slice(0, 19).replace('T', ' '),
        next_step: 'complete_assessments',
        q1: -1,
        q2: -1,
        q3a1: 0,
        q3a2: 0,
        q3a3: 0,
        q3a4: 0,
        q3a5: 0,
        q3a5_other: '',
        q3b1: 0,
        q3b2: 0,
        q3b3: 0,
        q3b4: 0,
        q3b5: 0,
        q3b5_other: '',
        q4a1: 0,
        q4a2: 0,
        q4a3: 0,
        q4a4: 0,
        q4a5: 0,
        q4a6: 0,
        q4a6_other: '',
        q4b1: 0,
        q4b2: 0,
        q4b3: 0,
        q4b4: 0,
        q4b5: 0,
        q4b6: 0,
        q4b6_other: '',
        q5: '',
        q6: '',
    }
    this.answerFields = [
      'q1','q2',
      'q3a1','q3a2','q3a3','q3a4','q3a5','q3a5_other',
      'q3b1','q3b2','q3b3','q3b4','q3b5','q3b5_other',
      'q4a1','q4a2','q4a3','q4a4','q4a5','q4a6','q4a6_other',
      'q4b1','q4b2','q4b3','q4b4','q4b5','q4b6','q4b6_other',
      'q5', 'q6'
    ]
    this._draft = null
  }

  componentDidMount() {
    this._draft = initAutosaveForForm(this, {
       formId: 'tqe',
       fields: this.answerFields,
       expireMs: 10 * 24 * 60 * 60 * 1000,
    })
    this.getAssmProcess()
  }

  componentDidUpdate(prevProps) {
    ensureAutosaveInitialized(this, '_draft', {
       formId: 'tqe',
       fields: this.answerFields,
       expireMs: 10 * 24 * 60 * 60 * 1000,
    }, prevProps)
  }

  componentWillUnmount() {
    detachAutosave(this, '_draft')
  }

  getAssmProcess = () => {
    var timepoint = this.props.match.params.timepoint
    var type = this.props.match.params.type

    var calTimepoint = {}
    axios({
      method: 'post',
      url: connectNode + 'patient/assessment/get_assm_process',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        type: this.props.match.params.type,
        timepoint: this.props.match.params.timepoint,
       }
    })
    .then(async (result) => {
      calTimepoint = await calculateTimepoint3_1(result['data'].timeline_start)
      const tp = Number(this.props.match.params.timepoint)
      const isExpiredCurrentMonthlyWindow =
        this.props.match.params.type == 'm' &&
        tp == calTimepoint.current_month &&
        calTimepoint.mod_months > 5
      const isExpiredCurrentSixMonthWindow =
        this.props.match.params.type == 'sm' &&
        tp == calTimepoint.current_sixmonth &&
        calTimepoint.mod_6m > 5

      if (isExpiredCurrentMonthlyWindow || isExpiredCurrentSixMonthWindow) {
        this.setState({
          status: 3,
          is_time_available: false,
          message: 'This questionnaire is past due and can no longer be submitted.',
        })
        this.getCompletedData(3)
        return
      }

      var next_step = ''
      if((this.props.match.params.type == 'm' && this.props.match.params.timepoint > calTimepoint.current_month) ||
         (this.props.match.params.type == 'sm' && this.props.match.params.timepoint > calTimepoint.current_sixmonth)) {
        this.props.onLoadLocation('assessment_list_2', 'Sorry, something went wrong! Please only select available assessment in this page.')
        this.props.history.push('/member/assessment_list')
      } else if((this.props.match.params.type == 'm' && this.props.match.params.timepoint == calTimepoint.current_month) ||
                (this.props.match.params.type == 'sm' && this.props.match.params.timepoint == calTimepoint.current_sixmonth)) {
        // Current timepoint => Fill the form //
        if(result['data'].status !== null) {
          if((result['data'].status == 1 && result['data'].step !== 'tqe')
              || result['data'].status == 2) {
            this.getCompletedData(2)
          }
        } else {
          if(this.props.match.params.type == 'm' || this.props.match.params.type == 'sm') {
            this.setState({
              next_step: 'complete_assessments',
            })
          } /*else {
            this.setState({
              next_step: 'complete_assessments',
            })
          }*/
        }
      } else {
        // Past timepoint //
        this.getCompletedData(3, true)
      }
    })

  }

  getCompletedData = (status, redirectIfMissing = false) => {
    axios({
      method: 'post',
      url: connectNode + 'patient/assessment/get_assm_data',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        type: this.props.match.params.type,
        timepoint: this.props.match.params.timepoint,
        frm: 'tqe',
       }
    }).then((result) => {
      if(result['data'].status == 1) {
        this.setState({
          status: status,
          q1: result['data'].q1,
          q2: result['data'].q2,
          q3a1: result['data'].q3a1,
          q3a2: result['data'].q3a2,
          q3a3: result['data'].q3a3,
          q3a4: result['data'].q3a4,
          q3a5: result['data'].q3a5,
          q3a5_other: result['data'].q3a5_other,
          q3b1: result['data'].q3b1,
          q3b2: result['data'].q3b2,
          q3b3: result['data'].q3b3,
          q3b4: result['data'].q3b4,
          q3b5: result['data'].q3b5,
          q3b5_other: result['data'].q3b5_other,
          q4a1: result['data'].q4a1,
          q4a2: result['data'].q4a2,
          q4a3: result['data'].q4a3,
          q4a4: result['data'].q4a4,
          q4a5: result['data'].q4a5,
          q4a6: result['data'].q4a6,
          q4a6_other: result['data'].q4a6_other,
          q4b1: result['data'].q4b1,
          q4b2: result['data'].q4b2,
          q4b3: result['data'].q4b3,
          q4b4: result['data'].q4b4,
          q4b5: result['data'].q4b5,
          q4b6: result['data'].q4b6,
          q4b6_other: result['data'].q4b6_other,
          q5: result['data'].q5,
          q6: result['data'].q6,
        })
      } else if(redirectIfMissing) {
        this.props.onLoadLocation('assessment_list_2', 'This questionnaire is past due and no longer available.')
        this.props.history.push('/member/assessment_list')
      }
    })
  }

  handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    // radio -> number
    // checkbox -> store 1/0 (or true/false if you prefer)
    const nextValue =
      type === "checkbox" ? (checked ? 1 : 0) : Number(value);

    this.setState({ [name]: nextValue }, () => {
      if (this.state.status === 1 && this._draft) {
        this._draft.savePartial(name, nextValue, this.state);
      }
    });
  };

  handleChange4 = (e, name, coerce = 'string') => {
    let v = e.target.value;
    if (coerce === 'number') {
      v = (v === '' || v === null || v === undefined) ? '' : Number(v);
    }
    this.setState({ [name]: v }, () => {
      if (this.state.status === 1) this._draft?.saveFromState(this.state);
    });
  }

  handleSubmit = (e) => {
    e.preventDefault()
    if (!this.state.is_time_available) {
      return
    }
    var timepoint = this.props.match.params.timepoint
    var type = this.props.match.params.type
    var next_step = this.state.next_step
    const anyQ3a = [this.state.q3a1,this.state.q3a2,this.state.q3a3,this.state.q3a4,this.state.q3a5].some(v => v === 1);
    const anyQ3b = [this.state.q3b1,this.state.q3b2,this.state.q3b3,this.state.q3b4,this.state.q3b5].some(v => v === 1);
    const anyQ4a = [this.state.q4a1,this.state.q4a2,this.state.q4a3,this.state.q4a4,this.state.q4a5,this.state.q4a6].some(v => v === 1);
    const anyQ4b = [this.state.q4b1,this.state.q4b2,this.state.q4b3,this.state.q4b4,this.state.q4b5,this.state.q4b6].some(v => v === 1);

    if(this.state.status === 1) {
      if(this.state.q1 === -1 || this.state.q2 === -1 ||
        !anyQ3a || !anyQ3b || !anyQ4a || !anyQ4b ||
        this.state.q5 === '' || this.state.q6 === '') {
        this.setState({
          message: 'Please complete all items ',
        })
        window.scrollTo(0, 0)
      } else {
        axios({
          method: 'post',
          url: connectNode + 'patient/assessment/add_tqe',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: {
            uid: this.props.authReducer.uid,
            user: this.state,
            type: type,
            timepoint: this.props.match.params.timepoint,
          }
        })
        .then((result) => {
          if(result['data'] == next_step) {
            if (this._draft) this._draft.clear()
            this.props.onLoadLocation('/member/assessment/'+result['data']+'/'+type+'/'+timepoint)
            this.props.history.push('/member/assessment/'+result['data']+'/'+type+'/'+timepoint)
          }
        })
      }
    } else {
      if (this._draft) this._draft.clear()
      this.props.onLoadLocation('/member/assessment/'+next_step+'/'+type+'/'+timepoint)
      this.props.history.push('/member/assessment/'+next_step+'/'+type+'/'+timepoint)
    }
  }

  render() {
    return (
      <div className="assm_phq9 box_border4 assm_tqe">
        <div className="row">
          <div className="small-12 columns headerPage1">
            FITT-BD Trackers and Questionnaires Experience
          </div>
          {//this.state.status == 1 &&
          <StepperAssm activeStep={3} assm={'TQE'} type={this.props.match.params.type} timepoint={this.props.match.params.timepoint} />}
        </div>
        { this.state.message !== '' &&
        <div className="row warning_msg6">
          <div className="small-12 columns ">
            <div className="float_left1"><WarningIcon /></div>
            <div className="txt_warning_msg1">{ this.state.message }</div>
          </div>
        </div>
        }
        <form onSubmit={this.handleSubmit}>
        <div className="row">
          <div className="small-12 columns box2_2">
            <b>IMPORTANT: </b>
            If you cannot complete this section in one sitting, you may return and finish it <b>on this device</b> without losing your data.
          </div>
          <div className="small-12 columns box1">
            <div className="row">

              <div className="small-12 columns bold3 margin-bottom1">1. {tqe_q1_2[0].label}</div>
              {answers_q1.map(each =>
                <div className="small-12 columns" key={'q1_'+each.value}>
                  <input type="radio" name={"q1"} value={each.value}
                  checked={this.state.q1 == each.value || this.state.q1 === each.value}
                  disabled={this.state.status > 1}
                  onChange={(e) => this.handleChange(e)}/> {each.label}
                </div>)}

              <div class="small-12 columns"><div class="sep_line2">&nbsp;</div></div>

              <div className="small-12 columns bold3 margin-bottom1">2. {tqe_q1_2[1].label}</div>
              {answers_q2.map(each =>
                <div className="small-12 columns" key={'q2_'+each.value}>
                  <input type="radio" name={"q2"} value={each.value}
                  checked={this.state.q2 == each.value || this.state.q2 === each.value}
                  disabled={this.state.status > 1}
                  onChange={(e) => this.handleChange(e)}/> {each.label}
                </div>)}

              <div class="small-12 columns"><div class="sep_line2">&nbsp;</div></div>

              <div className="small-12 columns bold3 margin-bottom1">3a. {tqe_q3a[0].label}</div>
              {answers_q3a.map(each => {
                const keyName = `q3a${each.value}`; // q3a1..q3a5
                return (
                  <div className="small-12 columns" key={'q3a_'+each.value}>
                    <input
                      type="checkbox"
                      name={keyName}
                      checked={this.state[keyName] === 1}
                      disabled={this.state.status > 1}
                      className="cb_space1"
                      onChange={this.handleChange}
                    /> {each.label}
                  </div>
                );
              })}

              <div className="small-12 columns">
                <TextField label="" variant="outlined" value={this.state.q3a5_other}
                InputProps={{ inputProps: { name: "q3a5_other", maxLength: 250 }}} name="q3a5_other"
                disabled={this.state.status > 1}
                onChange={(e) => this.handleChange4(e, 'q3a5_other')} className="w50p" />
              </div>

              <div class="small-12 columns"><div class="sep_line2">&nbsp;</div></div>

              <div className="small-12 columns bold3 margin-bottom1">3b. {tqe_q3b[0].label}</div>
              {answers_q3b.map(each => {
                const keyName = `q3b${each.value}`; // q3b1..q3b5
                return (
                  <div className="small-12 columns" key={'q3b_'+each.value}>
                    <input
                      type="checkbox"
                      name={keyName}
                      checked={this.state[keyName] === 1}
                      disabled={this.state.status > 1}
                      className="cb_space1"
                      onChange={this.handleChange}
                    /> {each.label}
                  </div>
                );
              })}

              <div className="small-12 columns">
              <TextField
                label=""
                variant="outlined"
                value={this.state.q3b5_other}
                InputProps={{ inputProps: { name: "q3b5_other", maxLength: 250 }}}
                name="q3b5_other"
                disabled={this.state.status > 1}
                onChange={(e) => this.handleChange4(e, 'q3b5_other')}
                className="w50p"
                />
              </div>

              <div class="small-12 columns"><div class="sep_line2">&nbsp;</div></div>

              <div className="small-12 columns bold3 margin-bottom1">4a. {tqe_q4a[0].label}</div>
              {answers_q4a.map(each => {
                const keyName = `q4a${each.value}`; // q4a1..q4a6
                return (
                  <div className="small-12 columns" key={'q4a_'+each.value}>
                    <input
                      type="checkbox"
                      name={keyName}
                      checked={this.state[keyName] === 1}
                      disabled={this.state.status > 1}
                      className="cb_space1"
                      onChange={this.handleChange}
                    /> {each.label}
                  </div>
                );
              })}

              <div className="small-12 columns">
                <TextField label="" variant="outlined" value={this.state.q4a6_other}
                InputProps={{ inputProps: { name: "q4a6_other", maxLength: 250 }}} name="q4a6_other"
                disabled={this.state.status > 1}
                onChange={(e) => this.handleChange4(e, 'q4a6_other')} className="w50p" />
              </div>

              <div class="small-12 columns"><div class="sep_line2">&nbsp;</div></div>

              <div className="small-12 columns bold3 margin-bottom1">4b. {tqe_q4b[0].label}</div>
              {answers_q4b.map(each => {
                const keyName = `q4b${each.value}`; // q4b1..q4b6
                return (
                  <div className="small-12 columns" key={'q4b_'+each.value}>
                    <input
                      type="checkbox"
                      name={keyName}
                      checked={this.state[keyName] === 1}
                      disabled={this.state.status > 1}
                      className="cb_space1"
                      onChange={this.handleChange}
                    /> {each.label}
                  </div>
                );
              })}

              <div className="small-12 columns">
              <TextField
                label=""
                variant="outlined"
                value={this.state.q4b6_other}
                InputProps={{ inputProps: { name: "q4b6_other", maxLength: 250 }}}
                name="q4b6_other"
                disabled={this.state.status > 1}
                onChange={(e) => this.handleChange4(e, 'q4b6_other')}
                className="w50p"
                />
              </div>

              <div class="small-12 columns"><div class="sep_line2">&nbsp;</div></div>

              <div className="small-12 columns bold3 margin-bottom1">5. {tqe_q5_6[0].label}</div>

              <div className="small-12 columns">
                <TextField label="" variant="outlined" value={this.state.q5}
                InputProps={{ inputProps: { name: "q5" }}} name="q5"
                disabled={this.state.status > 1}
                onChange={(e) => this.handleChange4(e, 'q5')} className="w100p" />
              </div>

              <div class="small-12 columns"><div class="sep_line2">&nbsp;</div></div>

              <div className="small-12 columns bold3 margin-bottom1">6. {tqe_q5_6[1].label}</div>

              <div className="small-12 columns">
                <TextField label="" variant="outlined" value={this.state.q6}
                InputProps={{ inputProps: { name: "q6" }}} name="q6"
                disabled={this.state.status > 1}
                onChange={(e) => this.handleChange4(e, 'q6')} className="w100p" />
              </div>


            </div>



          </div>

        <div className="small-12 columns align_right">
          <Button variant="contained" color="primary" disableElevation
             onClick={this.handleSubmit} type="submit" className="submit_1"
             disabled={!this.state.is_time_available}>
              { this.state.status === 1 ? 'Submit' : 'Next' }
          </Button>
        </div>
      </div>
      </form>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Tqe)
